// This probably should live elsewhere, but wanted to avoid spending time on finding a home.
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { useState } from "react";
import { exportBrokerData } from "../../api/routes";
import { ChartGroup } from "../../components/charts/Chart";
import styles from "./BrokerAnalytics.module.css";
import { useChartData } from "./data";
import { downloadBlob } from "../../util";
import { useToast } from "../../context-providers/Toast";
import { IfFeatureEnabled } from "../../IfFeatureEnabled";
import { useLocalUser } from "../../pages/specialty-assistant/data";

// TODO: I poached this from Extraction.tsx, which may not be the best match?
const EmptyState = () => {
  return (
    <div className={styles.emptyState}>
      <Skeleton width="120px" height="160px" />
      <Skeleton width="120px" height="300px" />
      <Skeleton width="120px" height="250px" />
      <div style={{ width: "100px" }} />
      <Skeleton width="120px" height="160px" />
      <Skeleton width="120px" height="300px" />
      <Skeleton width="120px" height="250px" />
      <div style={{ width: "100px" }} />
      <Skeleton width="120px" height="160px" />
      <Skeleton width="120px" height="300px" />
      <Skeleton width="120px" height="250px" />
    </div>
  );
};

export const BrokerAnalytics = () => {
  const breakdowns: {
    name: string;
    indicator: "current_month" | "last_month" | "past_year" | "year_to_date";
  }[] = [
    { name: "This month", indicator: "current_month" },
    { name: "Last month", indicator: "last_month" },
    { name: "Past year", indicator: "past_year" },
    { name: "Year-to-date", indicator: "year_to_date" },
  ];

  const [selectedRange, setSelectedRange] = useState(breakdowns[0]!);
  const [isExporting, setIsExporting] = useState(false);
  const user = useLocalUser();
  const toast = useToast();

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const blob = await exportBrokerData();
      const today = new Date().toISOString().split("T")[0];
      const filename = `brokers_${today}.xlsx`;
      downloadBlob(filename, blob);
    } catch (e) {
      toast.show({
        severity: "error",
        summary: "Export failed",
        detail: "An error occurred during export.",
      });
    } finally {
      setIsExporting(false);
    }
  };

  const bindRateChartData = useChartData({
    dateChoice: selectedRange.indicator,
    reportSelection: "brokerage_bind_rate",
  });
  const quotedRateChartData = useChartData({
    dateChoice: selectedRange.indicator,
    reportSelection: "brokerage_quoted_rate",
  });
  const submissionChartData = useChartData({
    dateChoice: selectedRange.indicator,
    reportSelection: "created",
  });

  return (
    <div className={styles.container}>
      <Card>
        <div className={styles.verticalContainer}>
          <div className={styles.headerContainer}>
            <div className={styles.horizontalContainer}>
              <Dropdown
                options={breakdowns}
                value={selectedRange}
                onChange={(e) => {
                  setSelectedRange(e.value);
                }}
                optionLabel="name"
              />
            </div>
            <IfFeatureEnabled feature="broker-export" user={user}>
              <Button
                label="Export Brokers"
                onClick={handleExport}
                loading={isExporting}
              />
            </IfFeatureEnabled>
          </div>
          {quotedRateChartData.data && quotedRateChartData.data.chart_groups ? (
            <ChartGroup
              chartGroups={quotedRateChartData.data.chart_groups}
              chartWidth={1200}
            />
          ) : (
            <EmptyState />
          )}
          {bindRateChartData.data && bindRateChartData.data.chart_groups ? (
            <ChartGroup
              chartGroups={bindRateChartData.data.chart_groups}
              chartWidth={1200}
            />
          ) : (
            <EmptyState />
          )}
          {submissionChartData.data && submissionChartData.data.chart_groups ? (
            <ChartGroup chartGroups={submissionChartData.data.chart_groups} />
          ) : (
            <EmptyState />
          )}
        </div>
      </Card>
    </div>
  );
};
